import { render, staticRenderFns } from "./GenresSelector.vue?vue&type=template&id=a3cac542&scoped=true"
import script from "./GenresSelector.vue?vue&type=script&lang=js"
export * from "./GenresSelector.vue?vue&type=script&lang=js"
import style0 from "./GenresSelector.vue?vue&type=style&index=0&id=a3cac542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cac542",
  null
  
)

export default component.exports